module.exports = __webpack_public_path__ + "img/allo-down-bg.fdc9b1a4.png";